import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgDiscord = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.7938 13.2878C16.7938 14.3324 16.0232 15.1885 15.0472 15.1885C14.0883 15.1885 13.3006 14.3324 13.3006 13.2878C13.3006 12.2433 14.0712 11.3871 15.0472 11.3871C16.0232 11.3871 16.7938 12.2433 16.7938 13.2878ZM8.79734 11.3871C7.82131 11.3871 7.05076 12.2433 7.05076 13.2878C7.05076 14.3324 7.83843 15.1885 8.79734 15.1885C9.77336 15.1885 10.5439 14.3324 10.5439 13.2878C10.561 12.2433 9.77336 11.3871 8.79734 11.3871ZM21.9999 16.781C21.9999 11.2673 19.5341 6.79809 19.5341 6.79809C17.0684 4.94877 14.7225 5.00014 14.7225 5.00014L14.4828 5.27412C17.3937 6.16453 18.7465 7.44877 18.7465 7.44877C14.6789 5.21947 9.90094 5.21907 5.95536 6.9522C5.3218 7.24329 4.94508 7.44877 4.94508 7.44877C4.94508 7.44877 6.36632 6.09603 9.44851 5.20562L9.27727 5.00014C9.27727 5.00014 6.93139 4.94877 4.46563 6.79809C4.46563 6.79809 1.99988 11.2673 1.99988 16.781C1.99988 16.781 3.43823 19.2638 7.22248 19.3837C7.22248 19.3837 7.85604 18.6132 8.36974 17.9625C6.19508 17.3118 5.37317 15.9419 5.37317 15.9419C5.62507 16.1182 6.04044 16.3468 6.07522 16.37C8.96544 17.9886 13.0709 18.5188 16.7602 16.9693C17.3595 16.7467 18.0273 16.4214 18.7293 15.959C18.7293 15.959 17.8732 17.3632 15.63 17.9967C16.1437 18.6474 16.7602 19.3837 16.7602 19.3837C20.5444 19.2638 21.9999 16.781 21.9999 16.781Z", fill: props.fill }));
});
export default SvgDiscord;
